import { UntypedFormGroup } from "@angular/forms";
import { UnitAcquisitionUpdate } from "src/swagger-gen/web-secured/models";

export class UnitAcquisitionUpdateModel implements UnitAcquisitionUpdate{

    uid: string;
    name: string;
    delta: string;
    period: string;
    excludeSpecialAcquisitions: boolean;

    constructor(unit: UntypedFormGroup){
        this.name = unit.controls.name.value,
        this.uid = unit.controls.uid.value,
        this.delta = unit.controls.delta.value.replace(',', '.'),
        this.period = unit.controls.period.value,
        this.excludeSpecialAcquisitions = unit.controls.excludeSpecials.value
    }

}
